import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { verifyInvite, setupAccount } from '../services/api';

const SetupAccount = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const { loginUser } = useAuth();

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [invalidToken, setInvalidToken] = useState(false);

  useEffect(() => {
    const verifyToken = async () => {
      try {
        const response = await verifyInvite(token);
        setUsername(response.data.username);
        setLoading(false);
      } catch (err) {
        setInvalidToken(true);
        setLoading(false);
      }
    };

    verifyToken();
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (password.length < 6) {
      setError('La password deve essere di almeno 6 caratteri');
      return;
    }

    if (password !== confirmPassword) {
      setError('Le password non corrispondono');
      return;
    }

    if (!acceptedTerms) {
      setError('Devi accettare i termini e le condizioni');
      return;
    }

    setSubmitting(true);

    try {
      const response = await setupAccount(token, password);
      const { token: authToken, ...userData } = response.data;
      loginUser(userData, authToken);
      navigate('/targets');
    } catch (err) {
      setError(err.response?.data?.message || 'Errore durante la configurazione');
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) {
    return (
      <div className="login-container">
        <div className="login-box">
          <p>Verifica in corso...</p>
        </div>
      </div>
    );
  }

  if (invalidToken) {
    return (
      <div className="login-container">
        <div className="login-box">
          <h1>Link non valido</h1>
          <p className="login-subtitle">
            Il link di invito non è valido o è scaduto.
          </p>
          <p>Contatta l'amministratore per ricevere un nuovo link.</p>
          <button
            className="btn btn-primary"
            onClick={() => navigate('/login')}
            style={{ marginTop: '20px' }}
          >
            Vai al Login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="login-container">
      <div className="login-box">
        <h1>Benvenuto!</h1>
        <p className="login-subtitle">
          Ciao <strong>{username}</strong>, completa la registrazione
        </p>

        <div className="setup-info">
          Per accedere userai:<br/>
          <strong>Username:</strong> {username}<br/>
          <strong>Password:</strong> quella che sceglierai qui sotto
        </div>

        <form onSubmit={handleSubmit}>
          {error && <div className="error-message">{error}</div>}

          <div className="form-group">
            <label htmlFor="password">Scegli una password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoFocus
              placeholder="Minimo 6 caratteri"
            />
          </div>

          <div className="form-group">
            <label htmlFor="confirmPassword">Conferma password</label>
            <input
              type="password"
              id="confirmPassword"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </div>

          <div className="terms-section">
            <h3>Termini e Condizioni</h3>
            <div className="terms-content">
              <p><strong>Informativa sulla Privacy e Trattamento Dati</strong></p>
              <p>
                Utilizzando questa applicazione, accetti che i tuoi dati personali
                (username, cronologia visite) vengano memorizzati e trattati ai fini
                della gestione delle visite.
              </p>
              <p>
                I dati sono conservati in modo sicuro e non verranno condivisi con
                terze parti. Puoi richiedere la cancellazione dei tuoi dati in
                qualsiasi momento contattando l'amministratore.
              </p>
              <p>
                <strong>Responsabilità:</strong> L'utilizzo dell'applicazione è sotto
                la tua responsabilità. Le informazioni inserite devono essere accurate
                e utilizzate solo per gli scopi previsti.
              </p>
            </div>

            <label className="checkbox-label">
              <input
                type="checkbox"
                checked={acceptedTerms}
                onChange={(e) => setAcceptedTerms(e.target.checked)}
              />
              Accetto i termini e le condizioni
            </label>
          </div>

          <button
            type="submit"
            className="btn btn-primary"
            disabled={submitting || !acceptedTerms}
          >
            {submitting ? 'Configurazione...' : 'Completa registrazione'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default SetupAccount;
